const STORAGE_KEY = 'jabberr.theme';
const ORDER: string[] = ['system', 'light', 'dark'];

/* Module-level storage for testability. Tests replace this object's methods. */
export const _storage: { getItem: (key: string) => string | null; setItem: (key: string, val: string) => void } = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, val: string): void {
    try {
      localStorage.setItem(key, val);
    } catch {
      /* storage unavailable; silently ignore */
    }
  },
};

/* Module-level DOM helper for testability. Tests replace this object's methods. */
export const _docEl: { setAttribute: (name: string, val: string) => void; removeAttribute: (name: string) => void } = {
  setAttribute(name: string, val: string): void {
    document.documentElement!.setAttribute(name, val);
  },
  removeAttribute(name: string): void {
    document.documentElement!.removeAttribute(name);
  },
};

export function getTheme(): string {
  return _storage.getItem(STORAGE_KEY) ?? 'system';
}

export function setTheme(theme: string): void {
  const current = getTheme();
  if (current === theme) return;
  _storage.setItem(STORAGE_KEY, theme);
  if (theme === 'system') {
    _docEl.removeAttribute('data-theme');
  } else {
    _docEl.setAttribute('data-theme', theme);
  }
}

export function cycleTheme(): string {
  const current = getTheme();
  const idx = ORDER.indexOf(current);
  const next = ORDER[(idx + 1) % ORDER.length]!;
  setTheme(next);
  return next;
}

export function getThemeLabel(theme: string): string {
  return theme.charAt(0).toUpperCase() + theme.slice(1);
}

export function getNextTheme(current: string): string {
  const idx = ORDER.indexOf(current);
  return ORDER[(idx + 1) % ORDER.length]!;
}
